export const  firebaseConfig = {
        apiKey: "AIzaSyAobyXlUgoWmc8IMmoDQGyvEgOof6x6ZZw",
        authDomain: "valunteer-network.firebaseapp.com",
        databaseURL: "https://valunteer-network.firebaseio.com",
        projectId: "valunteer-network",
        storageBucket: "valunteer-network.appspot.com",
        messagingSenderId: "871687340604",
        appId: "1:871687340604:web:0061e5ebeaecf2c07e7939"
      };